module.exports = __webpack_public_path__ + "static/media/6.e50c3aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/6.jpg
// module id = 539
// module chunks = 0